module.exports = __webpack_public_path__ + "img/bg_login.c6017d9e.jpg";